import { useEffect } from "react";
import { useMap } from "react-leaflet";

export const FitBounds = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    if (points.length > 1) {
      map.fitBounds(points, { padding: [40, 40] });
    } else if (points.length === 1) {
      map.setView(points[0], 12);
    }
  }, [map, points]);
  return null;
};
